module.exports = __webpack_public_path__ + "static/media/profile.65faa39d.jpg";